import React from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ArtistPage from 'pages/ArtistPage';
import LoginPage from 'pages/LoginPage';
import FormsPage from 'pages/FormsPage';
import ArtistLanding from 'components/artists/ArtistLanding'
import WorkflowsPage from 'pages/WorkflowsPage';
import LandingPage from 'pages/LandingPage';
import UserHomePage from 'pages/UserHomePage';
import UserProfilePage from 'pages/UserProfilePage';
import AdminPage from 'pages/AdminPage';
import TeamsPage from 'pages/TeamsPage';
import OperationsPage from 'pages/OperationsPage';
import TeamsInviteAcceptPage from 'pages/TeamsInviteAcceptPage';
import NodePage from 'pages/NodePage';
import Project from 'components/projects/Project';
import BootstrapRoute from 'pages/BootstrapRoute';
import AuthenticatedShell from 'components/layout/AuthenticatedShell';
import FAQPage from 'pages/FAQPage';

const router = createBrowserRouter([
  { path: "", element: <LandingPage /> },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/bootstrap",
    element: <BootstrapRoute />,
  },
  {
    path: "/home",
    element: (
      <AuthenticatedShell>
        <UserHomePage />
      </AuthenticatedShell>
    ),
  },
  {
    path: "/faq",
    element: (
      <AuthenticatedShell>
        <FAQPage />
      </AuthenticatedShell>
    ),
  },
  {
    path: "/artist/:artistId",
    element: (
      <AuthenticatedShell>
        <ArtistPage />
      </AuthenticatedShell>
    ),
    children: [
      { index: true, element: <ArtistLanding /> },
      { path: "teams/:teamId/forms", element: <FormsPage /> },
      { path: "teams/:teamId/workflows", element: <WorkflowsPage /> },
      { path: "teams/:teamId", element: <TeamsPage /> },
      {
        path: "teams/:teamId/operations",
        element: <OperationsPage />,
        children: [
          { path: "workflows/:workflowTemplateId/start", element: <NodePage /> }
        ]
      },
      { path: "teams/:teamId/workflows/:workflowId/projects", element: <Project /> },
      { path: "teams/:teamId/workflows/:workflowId/projects/:projectId", element: <Project /> }
    ],
  },
  {
    path: "/teams/:teamId/teaminvites/accept",
    element: <TeamsInviteAcceptPage />,
  },
  {
    path: "/teams/:teamId/workflows/:workflowTemplateId/start",
    element: (
      <AuthenticatedShell>
        <NodePage />
      </AuthenticatedShell>
    ),
  },
  {
    path: "/profile",
    element: (
      <AuthenticatedShell>
        <UserProfilePage />
      </AuthenticatedShell>
    ),
  },
  {
    path: "/userHomePage",
    element: (
      <AuthenticatedShell>
        <UserHomePage />
      </AuthenticatedShell>
    )
  },
  {
    path: "/admin", element: <AdminPage />
  }
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
}

export default App;
